// EditSaleInvoice.js
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import AddSaleInvoice from './AddSaleInvoice';
import axios from 'axios';
import dayjs from 'dayjs';

const BASE_URL = process.env.REACT_APP_BASE_URL || '';

const EditSaleInvoice = () => {
  const { id } = useParams(); // Invoice ID from URL
  const navigate = useNavigate();

  const [initialData, setInitialData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!id) {
      setError('No invoice ID provided.');
      setLoading(false);
      return;
    }

    const fetchInvoice = async () => {
      try {
        const token = localStorage.getItem("token");

const response = await axios.get(`${BASE_URL}/SalesInvoice/Get/${id}`, {
  headers: {
    Authorization: `Bearer ${token}`,
  },
});
        if (response.data?.data) {
          const invoice = response.data.data;

          console.log(invoice);

          // Map invoice data to AddSaleInvoice state structure
          const transformedData = {
  invoiceNo: invoice.InvoiceNumber,
  invoiceDate: dayjs(invoice.InvoiceDate),
  reverseCharge: invoice.ReverseCharge,
  challanNo: invoice.ChallanNumber,
  transportationMode: invoice.TransportationMode,
  vehicleNo: invoice.VehicleNumber,
  dateOfSupply: invoice.DateOfSupply
  ? dayjs(invoice.DateOfSupply)
  : null,
  //dateOfSupply: dayjs(invoice.DateOfSupply),
  placeOfSupply: invoice.PlaceOfSupply,
  transporterID: invoice.TransporterId,
  transporterName: invoice.TransporterName,
  lrNumber: invoice.LrBiltyNumber,
  lrDate: invoice.LrDate
  ? dayjs(invoice.LrDate)
  : null,
 // lrDate: dayjs(invoice.LrDate),
  invoiceType: invoice.InvoiceType || "Tax Invoice", // ✅ Added
  isSameDetails: invoice.ConsigneeShippedtoSame ?? true,
  localReceiverData: {
    firstName: invoice.ReceiverDetails?.Name,
    address: invoice.ReceiverDetails?.Address,
    gst: invoice.ReceiverDetails?.GSTNumber,
    stateName: invoice.ReceiverDetails?.StateId,
    stateCode: invoice.ReceiverDetails?.StateCode?.toString()
  },
  consigneeDetails: invoice.ConsigneeDetails
    ? {
        name: invoice.ConsigneeDetails?.Name,
        address: invoice.ConsigneeDetails?.Address,
        gstin: invoice.ConsigneeDetails?.GSTNumber,
        state: invoice.ConsigneeDetails?.StateId,
        stateCode: invoice.ConsigneeDetails?.StateCode?.toString()
      }
    : {},
  rows: invoice.Products.map((p, index) => {
    const selectValue = p.ProductId || p.ProductName || p.ProductId; 
    const qty = parseFloat(p.Quantity?.$numberDecimal || p.Quantity || 0);
    const rate = parseFloat(p.Rate?.$numberDecimal || p.Rate || 0);
    const cgst = parseFloat(p.CGSTPercentage?.$numberDecimal || p.CGSTPercentage || 0);
    const sgst = parseFloat(p.SGSTPercentage?.$numberDecimal || p.SGSTPercentage || 0);
    const igst = parseFloat(p.IGSTPercentage?.$numberDecimal || p.IGSTPercentage || 0);

    return {
      id: index + 1,
      productId: p.ProductId,
      productName: p.ProductName || null,
      hsn: p.HsnSacCode || p.HSNCode || '',
      unit: p.UnitId || p.Unit || '',
      qty: String(p.Quantity?.$numberDecimal ?? p.Quantity ?? 0),  // string for input
      rate: String(p.Rate?.$numberDecimal ?? p.Rate ?? 0),
      originalRate: String(p.Rate?.$numberDecimal ?? p.Rate ?? 0),
      discount: String(p.DiscountPercentage?.$numberDecimal ?? p.DiscountPercentage ?? 0),
      discountQty: String(p.DiscountAmount?.$numberDecimal ?? p.DiscountAmount ?? 0),
      taxableValue: String(p.TaxableValue?.$numberDecimal ?? p.TaxableValue ?? 0),
      igstRate: String(p.IGSTPercentage?.$numberDecimal ?? p.IGSTPercentage ?? 0),
      cgstRate: String(p.CGSTPercentage?.$numberDecimal ?? p.CGSTPercentage ?? 0),
      sgstRate: String(p.SGSTPercentage?.$numberDecimal ?? p.SGSTPercentage ?? 0),
      gstPercentage: ((parseFloat(p.IGSTPercentage?.$numberDecimal ?? p.IGSTPercentage ?? 0)) || 
                      (parseFloat(p.CGSTPercentage?.$numberDecimal ?? p.CGSTPercentage ?? 0) + parseFloat(p.SGSTPercentage?.$numberDecimal ?? p.SGSTPercentage ?? 0))
                     ).toFixed(2),
      otherCharges: String(p.OtherCharges?.$numberDecimal ?? p.OtherCharges ?? 0),
      cess: String(p.Cess?.$numberDecimal ?? p.Cess ?? 0),
      total: String(p.Total?.$numberDecimal ?? p.Total ?? 0),
      taxType: (parseFloat(p.IGSTPercentage?.$numberDecimal ?? p.IGSTPercentage ?? 0) > 0) ? 'IGST' : 'SGST_CGST'
    };
  })
};

          setInitialData(transformedData);
        } else {
          setError('Invoice not found');
        }
      } catch (err) {
        console.error('Error fetching invoice:', err);
        setError('Failed to fetch invoice data.');
      } finally {
        setLoading(false);
      }
    };

    fetchInvoice();
  }, [id]);

  if (loading) return <div>Loading invoice data...</div>;
  if (error) return <div>Error: {error}</div>;

  return <AddSaleInvoice editModeSale={true} initialValues={initialData} invoiceId={id} />;
};

export default EditSaleInvoice;